module.exports = __webpack_public_path__ + "img/axle_conf_10.bd574dee.jpg";